import { UPDATE_TOKEN } from '../actions/authActions';

function getInitialState() {
    return { shouldUpdateToken: false };
}

function authReducer(state = getInitialState(), action) {
    const { type } = action;

    switch (type) {
        case UPDATE_TOKEN:
            return { ...getInitialState(), shouldUpdateToken: true };
        default:
            return state;
    }
}

export default authReducer;
